import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './EditionsSection.scss';

import CONFIG from "../../../config";
import ComparisonTableBlock from '../../Blocks/ComparisonTable/ComparisonTableBlock';
import CollectorEditionBlock from '../../Blocks/CollectorEdition/CollectorEditionBlock';

interface IEditionsSectionProps {
  context?: IContent;
}

const EditionsSection = ({ context }: IEditionsSectionProps) => {
  return (
    <div className="section-editions">
      <ComparisonTableBlock />
      {(window as any).__PRERENDER_INJECTED === undefined && !CONFIG.isUPC && (
        <CollectorEditionBlock />
      )}
    </div>
  );
};

export default withContent(EditionsSection);
